var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_8)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_89_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 27.2998,
    r: 22.5,
    fill: "#EDC346"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 27.2998,
    r: 18.5,
    stroke: "white",
    strokeWidth: 8,
    fill: "#8dd41a"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#8dd41a"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_89_8",
    x: 0.0000486374,
    y: -0.000195503,
    width: 54.6,
    height: 54.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    fill: "#8dd41a"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_89_8",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feOffset", {
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2,
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_89_8",
    fill: "#8dd41a"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_89_8",
    result: "shape",
    fill: "#8dd41a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_8",
    fill: "#8dd41a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerGreen);
export default __webpack_public_path__ + "static/media/map-marker-green.514c3d09be404b3230772c492ddfb79c.svg";
export { ForwardRef as ReactComponent };